export default __webpack_public_path__ + "static/Sam-3cff66766954b927ddcb5a9ce40883f4.png";